"use client";
import Button from "@/components/common/Button";
import { SSO_LOGIN_TEXT } from "@/constants";
import Image from "next/image";
import {
  RiInformationLine,
} from "react-icons/ri";

const SSO_LOGIN_URL =
  process.env.NEXT_PUBLIC_AUTH_API_URL ?? "http://localhost:3001";

export default function LoginPage() {
  const handleSignIn = () => {
    const frontendUrl =
      process.env.NEXT_PUBLIC_FRONTEND_URL || "http://localhost:3001";
    const redirectUri = `${frontendUrl}/auth/callback`;
    window.location.href = `${SSO_LOGIN_URL}/auth/staff/microsoft/login?redirect_uri=${encodeURIComponent(
      redirectUri
    )}`;
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <section className="w-full max-w-md px-6">
        <header className="mb-8 text-center">
          <Image
            src="/images/westay-black.svg"
            alt="Westay Logo"
            width={160}
            height={48}
            priority
            className="mx-auto object-contain"
            style={{ width: 'auto', height: 'auto', maxWidth: '160px' }}
          />
          <p className="mt-6 text-md text-slate-500">
            {SSO_LOGIN_TEXT.DESCRIPTION}
          </p>
        </header>
        <div className="rounded-2xl border border-slate-200 bg-white p-8 sm:p-10 shadow-xl space-y-6">
          <Button
            onClick={handleSignIn}
            label={SSO_LOGIN_TEXT.BUTTON_LABEL}
            icon={
              <svg className="w-5 h-5" viewBox="0 0 23 23" fill="none">
                <path d="M11 0H0v11h11V0z" fill="#F25022"></path>
                <path d="M23 0H12v11h11V0z" fill="#7FBA00"></path>
                <path d="M11 12H0v11h11V12z" fill="#00A4EF"></path>
                <path d="M23 12H12v11h11V12z" fill="#FFB900"></path>
              </svg>
            }
            styleClass="w-full bg-white gap-3 px-6 py-4 border-2 border-gray-300 rounded-xl hover:border-gray-400 hover:shadow-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed group whitespace-nowrap"
            labelClass="text-base font-medium text-gray-700 group-hover:text-gray-900"
          />
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-white text-gray-500">
                {SSO_LOGIN_TEXT.SECURE_AUTH_TEXT}
              </span>
            </div>
          </div>
          <footer className="mt-6 text-sm text-slate-500 border-blue-100">
            <div className="bg-blue-50 rounded-xl p-4 border">
              <div className="flex gap-3">
                <div className="flex-shrink-0">
                  <RiInformationLine className="text-xl text-blue-600" />
                </div>
                <div className="">
                  <p className="text-sm font-medium text-blue-900 mb-1">
                    {SSO_LOGIN_TEXT.MS_ACCOUNT_REQUIRED.TITLE}
                  </p>
                  <p className="text-sm text-blue-700">
                    {SSO_LOGIN_TEXT.MS_ACCOUNT_REQUIRED.DESCRIPTION}
                  </p>
                </div>
              </div>
            </div>
          </footer>
        </div>

      </section>
    </main>
  );
}
